import { PcpMode } from "./actions";

export const selectSelectedPcpLine = (mode: PcpMode) => (state: any) =>
  state.pcpSelection?.byMode?.[mode]?.selectedLine ?? null;

export const selectSelectedPcpLineIndex = (mode: PcpMode) => (state: any) =>
  state.pcpSelection?.byMode?.[mode]?.selectedLineIndex ?? null;

export const selectSelectedPcpRow = (mode: PcpMode) => (state: any) =>
  state.pcpSelection?.byMode?.[mode]?.selectedRow ?? null;
